<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('usersPage.updateUserData') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-body">
                    <el-form :model="user" class="add-user-form">
                        <el-row>
                            <el-col>
                                <base-input
                                    :label="$t('general.name')"
                                    type="text"
                                    name="name"
                                    v-validate="userValidations.name"
                                    :error="getError('name')"
                                    v-model="user.name">
                                </base-input>

                                <base-input
                                    :label="$t('general.emailAddress')"
                                    type="email"
                                    name="email"
                                    v-validate="userValidations.email"
                                    :error="getError('email')"
                                    v-model="user.email">
                                </base-input>

                                <div class="user-form-group">
                                    <label class="form-control-label">{{ $t('general.role') }}</label>
                                    <el-select
                                        name="role"
                                        v-validate="userValidations.role"
                                        :error="getError('role')"
                                        v-model="user.role">
                                        <el-option value="user" :label="$t('general.user')"></el-option>
                                        <el-option value="admin" :label="$t('general.admin')"></el-option>
                                    </el-select>
                                </div>

                            </el-col>
                            <el-col :span="12">
                                <div class="grid-content bg-purple-light"></div>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="card-footer no-border">
                    <base-button
                        v-if="me.role === 'admin'"
                        type="danger"
                        @click.prevent="deleteUserAttention">
                        <i class="ai ai-remove"></i> {{ $t('usersPage.deleteUser') }}
                    </base-button>
                    <base-button
                        type="success"
                        @click.prevent="updateUserData">
                        <i class="ai ai-save"></i> {{ $t('general.update') }}
                    </base-button>
                </div>

            </div>

            <el-dialog
                v-if="me.role === 'admin'"
                :title="$t('general.warning')"
                :visible.sync="showDeleteUserAttentionModal"
                width="550px"
                center>
                <div class="h2 text-center">{{ $t('usersPage.warningQuestion') }}</div>
                <div slot="footer" class="dialog-footer">
                    <base-button
                        outline
                        type="secondary"
                        @click="showDeleteUserAttentionModal = false">{{ $t('general.cancel') }}
                    </base-button>
                    <base-button type="danger" @click="deleteUser">{{ $t('general.delete') }}</base-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import {Form, Row, Col, Select, Option, Dialog} from 'element-ui'
    import VeeValidateMixin from '@/mixins/vee-validate-mixin'
    import DeleteUserMixin from '@/mixins/delete-user'
    import {mapGetters} from 'vuex'

    export default {
        mixins: [VeeValidateMixin, DeleteUserMixin],
        components: {
            [Form.name]: Form,
            [Row.name]: Row,
            [Col.name]: Col,
            [Select.name]: Select,
            [Option.name]: Option,
            [Dialog.name]: Dialog,
        },
        data() {
            return {
                user: {
                    name: null,
                    email: null,
                    role: null
                },
                userValidations: {
                    name: {
                        required: true,
                        min: 5,
                        max: 191,
                    },
                    email: {
                        required: true,
                        email: true,
                        max: 191,
                    },
                    role: {
                        required: true,
                        included: ['user', 'admin'],
                    },
                }
            }
        },
        computed: {
            ...mapGetters({
                me: 'getUser'
            })
        },
        methods: {
            async updateUserData() {
                const isValid = await this.$validator.validateAll();

                if (isValid) {
                    this.$axios.put('/api/users/' + this.$route.params.userId, this.user)
                        .then(res => {
                            this.$notify({
                                title: this.$t('usersPage.userUpdated')
                            });
                            this.$router.push('/users')
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                }
            },
        },
        beforeCreate() {
            console.log(this.$store.getters.getUser);
            if (parseInt(this.$store.getters.getUser.id) === parseInt(this.$route.params.userId)) {
                this.$router.push('/my-account')
            }
        },
        async created() {
            await this.$axios.get('/api/users/' + this.$route.params.userId)
                .then(res => {
                    this.user = res.data.data;
                })
                .catch(err => {
                    this.$router.push('/users')
                })
        }
    }
</script>

<style lang="scss">
    $tableBorder: 1px solid #E3E3E3;

    .add-user-form {
        .el-select, label {
            display: block;
        }

        input, .el-select {
            max-width: 400px;
        }

        .user-form-group {
            margin-bottom: 1rem;
        }
    }

    .permission-table {
        border: $tableBorder;
        border-radius: 4px;
        width: 100%;

        thead {
            border-bottom: $tableBorder;
            font-size: 14px;
        }

        tr {
            &:not(:last-child) {
                border-bottom: $tableBorder;
            }

            th, td {
                padding: 6px 10px;

                &:not(:first-child) {
                    border-left: $tableBorder;
                    text-align: center;
                }

                &:first-child {
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }

        select {
            width: auto;
            padding: 6px 10px;
            height: 32px;
            font-size: .775rem;
            margin: auto;
        }
    }

    .card-footer {
        .no-border {
            border: none;
        }
    }
</style>
